import { getTagVariantFromPaymentRequestState } from '@mews-commander/utils';
import { LocalizedEnum } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { PaymentRequestState } from '@mews-commander/data-access';

interface Props {
    state: PaymentRequestState;
    outline?: boolean;
}

export const PaymentRequestStateTag = ({ state, outline = true }: Props) => {
    return (
        <Tag variant={getTagVariantFromPaymentRequestState(state)} outline={outline}>
            <LocalizedEnum prefix="PaymentRequestState" value={state} />
        </Tag>
    );
};
